(function () {
  'use strict';

  var ui = window.ByteRescueUI;
  if (!ui || !window.ByteRescueCaptcha || window.ByteRescueRequestLoaded) return;
  window.ByteRescueRequestLoaded = true;
  var root = document.documentElement;
  var reduceMotion = ui.reduceMotion;
  var scopedNodes = ui.scopedNodes;
  var uiMessage = ui.uiMessage;
  var fillMessage = ui.fillMessage;
  var formValue = ui.formValue;
  var publishAnalyticsEvent = ui.publishAnalyticsEvent;
  var initializeRequestSecurity = window.ByteRescueCaptcha.initialize;
  var requestRecaptchaToken = window.ByteRescueCaptcha.token;

  function copyProblemToForm(button) {
    var category = document.querySelector('[data-problem-category]');
    if (!category || !button) return;
    var value = button.getAttribute('data-form-value');
    var match = Array.prototype.some.call(category.options, function (option) { return option.value === value; });
    if (match) category.value = value;
  }

  function updateDesktopProblemPlan(section, button) {
    var plan = section && section.querySelector('[data-problem-plan]');
    if (!plan || !button) return;
    ['title', 'copy', 'step-one', 'step-two', 'step-three'].forEach(function (key) {
      var target = plan.querySelector('[data-plan-' + key + ']');
      if (target) {
        var value = button.getAttribute('data-plan-' + key) || '';
        target.textContent = value;
        if (key === 'copy') target.hidden = !value;
      }
    });
  }

  function closeMobileProblemItems(section) {
    scopedNodes(section, '[data-problem-item]').forEach(function (item) { item.classList.remove('is-open'); });
    scopedNodes(section, '[data-problem-option]').forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-pressed', 'false');
      item.setAttribute('aria-expanded', 'false');
    });
    scopedNodes(section, '[data-mobile-problem-plan]').forEach(function (panel) { panel.hidden = true; });
  }

  function configureProblemSection(section) {
    if (!section) return;
    var mobile = window.innerWidth <= 820;
    var mode = mobile ? 'mobile' : 'desktop';
    if (section.getAttribute('data-problem-mode') === mode) return;
    section.setAttribute('data-problem-mode', mode);
    var buttons = scopedNodes(section, '[data-problem-option]');
    var desktopPlan = section.querySelector('[data-problem-plan]');
    closeMobileProblemItems(section);
    if (mobile) {
      buttons.forEach(function (button) { button.setAttribute('aria-controls', button.getAttribute('data-mobile-panel') || ''); });
      return;
    }
    var active = buttons[0];
    if (!active) return;
    active.classList.add('is-active');
    active.setAttribute('aria-pressed', 'true');
    active.setAttribute('aria-expanded', 'true');
    if (desktopPlan) active.setAttribute('aria-controls', desktopPlan.id);
    buttons.slice(1).forEach(function (button) { if (desktopPlan) button.setAttribute('aria-controls', desktopPlan.id); });
    updateDesktopProblemPlan(section, active);
  }

  function keepProblemAnchor(button, previousTop) {
    var delta = button.getBoundingClientRect().top - previousTop;
    if (Math.abs(delta) <= 1) return;
    var previousBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollBy(0, delta);
    root.style.scrollBehavior = previousBehavior;
    ui.resetScrollIntent();
  }

  function selectProblem(button) {
    var section = button.closest('[data-problem-section]');
    if (!section) return;
    copyProblemToForm(button);
    publishAnalyticsEvent('problem_selected', {
      problem_category: button.getAttribute('data-form-value') || 'other'
    });
    if (window.innerWidth <= 820) {
      var previousTop = button.getBoundingClientRect().top;
      var panelId = button.getAttribute('data-mobile-panel');
      var panel = panelId && document.getElementById(panelId);
      var willOpen = button.getAttribute('aria-expanded') !== 'true';
      closeMobileProblemItems(section);
      if (willOpen && panel) {
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        button.setAttribute('aria-expanded', 'true');
        var item = button.closest('[data-problem-item]');
        if (item) item.classList.add('is-open');
        panel.hidden = false;
      }
      keepProblemAnchor(button, previousTop);
      return;
    }
    scopedNodes(section, '[data-problem-option]').forEach(function (item) {
      var active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
      item.setAttribute('aria-expanded', String(active));
      var plan = section.querySelector('[data-problem-plan]');
      if (plan) item.setAttribute('aria-controls', plan.id);
    });
    updateDesktopProblemPlan(section, button);
  }

  function setAreaZone(section, index, fromZip) {
    if (!section) return;
    var experience = section.querySelector('[data-area-experience]');
    var cards = scopedNodes(section, '[data-area-zone]');
    var mapTargets = scopedNodes(section, '[data-area-map-zone]');
    var normalizedIndex = String(index || 0);
    if (experience) experience.setAttribute('data-active-zone', normalizedIndex);
    cards.forEach(function (card) {
      var active = card.getAttribute('data-zone-index') === normalizedIndex;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-pressed', String(active));
      if (active && fromZip && window.innerWidth <= 580) {
        card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      }
    });
    mapTargets.forEach(function (target) {
      var active = target.getAttribute('data-area-map-zone') === normalizedIndex;
      target.setAttribute('aria-pressed', String(active));
    });
  }

  function setAreaControlsLocked(section, locked) {
    scopedNodes(section, '[data-area-zone]').forEach(function (card) {
      card.disabled = locked;
      card.setAttribute('aria-disabled', String(locked));
    });
    scopedNodes(section, '[data-area-map-zone]').forEach(function (target) {
      target.setAttribute('tabindex', locked ? '-1' : '0');
      target.setAttribute('aria-disabled', String(locked));
    });
  }

  function clearAreaMatch(section) {
    var experience = section && section.querySelector('[data-area-experience]');
    if (experience) experience.classList.remove('has-zip-result');
    setAreaControlsLocked(section, false);
    hideAreaZipMarker(section);
    var defaultIndex = experience && experience.getAttribute('data-default-zone') || '1';
    if (section && section._brSetAreaResting) section._brSetAreaResting(defaultIndex); else setAreaZone(section, defaultIndex, false);
    var requestZone = document.querySelector('[data-request-zone]');
    if (requestZone) {
      requestZone.hidden = true;
      requestZone.removeAttribute('data-zone-status');
    }
    var requestLink = section && section.querySelector('[data-area-request-link]');
    if (requestLink) {
      requestLink.textContent = uiMessage(section, 'start-request', 'Start a request →');
      requestLink.hidden = true;
    }
    var emptyState = section && section.querySelector('[data-area-empty-state]');
    if (emptyState) emptyState.hidden = false;
    scopedNodes(section || document, '[data-area-result]').forEach(function (result) { result.hidden = true; });
  }

  function initializeArea(section) {
    if (!section || section.getAttribute('data-area-ready') === 'true') return;
    section.setAttribute('data-area-ready', 'true');
    var experience = section.querySelector('[data-area-experience]');
    var cards = scopedNodes(section, '[data-area-zone]');
    var mapTargets = scopedNodes(section, '[data-area-map-zone]');
    var controls = cards.concat(mapTargets);
    var restingIndex = (experience && experience.getAttribute('data-default-zone')) || '1';

    function zoneIndex(control) { return control.getAttribute('data-zone-index') || control.getAttribute('data-area-map-zone') || '0'; }
    function configureMode() {
      setAreaControlsLocked(section, Boolean(experience && experience.classList.contains('has-zip-result')));
      setAreaZone(section, restingIndex, false);
    }
    controls.forEach(function (control) {
      control.addEventListener('pointerenter', function () { if (window.innerWidth > 580 && !(experience && experience.classList.contains('has-zip-result'))) setAreaZone(section, zoneIndex(control), false); });
      control.addEventListener('click', function () {
        if (experience && experience.classList.contains('has-zip-result')) return;
        restingIndex = zoneIndex(control);
        setAreaZone(section, restingIndex, false);
      });
      control.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (control.tagName.toLowerCase() === 'button') return;
        event.preventDefault();
        if (experience && experience.classList.contains('has-zip-result')) return;
        restingIndex = zoneIndex(control);
        setAreaZone(section, restingIndex, false);
      });
    });
    if (experience) experience.addEventListener('pointerleave', function () { if (window.innerWidth > 580) setAreaZone(section, restingIndex, false); });
    section._brSetAreaResting = function (index) { restingIndex = String(index || 0); setAreaZone(section, restingIndex, true); };
    window.addEventListener('resize', configureMode);
    configureMode();
  }

  function normalizeZip(value) { return String(value || '').replace(/\D/g, '').slice(0, 5); }

  function addressLocalityForZip(zip) {
    var normalized = normalizeZip(zip);
    var cityByZip = {
      '60016': 'Des Plaines', '60018': 'Des Plaines',
      '60025': 'Glenview', '60026': 'Glenview', '60029': 'Golf',
      '60053': 'Morton Grove', '60062': 'Northbrook', '60068': 'Park Ridge',
      '60076': 'Skokie', '60077': 'Skokie', '60091': 'Wilmette', '60093': 'Winnetka',
      '60176': 'Schiller Park', '60201': 'Evanston', '60202': 'Evanston',
      '60203': 'Evanston', '60208': 'Evanston', '60706': 'Harwood Heights',
      '60707': 'Elmwood Park', '60712': 'Lincolnwood', '60714': 'Niles'
    };
    var prefix = Number(normalized.slice(0, 3));
    return {
      city: normalized.indexOf('606') === 0 ? 'Chicago' : (cityByZip[normalized] || ''),
      state: prefix >= 600 && prefix <= 629 ? 'IL' : ''
    };
  }

  function populateServiceAddress(form) {
    if (!form) return;
    var zip = normalizeZip(formValue(form, 'zip'));
    var postal = form.querySelector('[data-address-zip]');
    var city = form.querySelector('[data-address-city]');
    var state = form.querySelector('[data-address-state]');
    var previousZip = postal ? normalizeZip(postal.value) : '';
    var locality = addressLocalityForZip(zip);
    if (postal) postal.value = zip;
    [[city, locality.city], [state, locality.state]].forEach(function (pair) {
      var field = pair[0];
      var value = pair[1];
      if (!field) return;
      var mayAutofill = previousZip !== zip || !field.value || field.getAttribute('data-br-autofilled') === 'true';
      if (!mayAutofill) return;
      field.value = value;
      if (value) field.setAttribute('data-br-autofilled', 'true');
      else field.removeAttribute('data-br-autofilled');
    });
  }

  function resetRequestTiming(form) {
    var planner = form && form.querySelector('[data-arrival-planner]');
    if (!planner) return;
    scopedNodes(planner, '[name="urgency"]').forEach(function (field) { field.checked = false; });
    var date = planner.querySelector('[name="preferred_date"]');
    var time = planner.querySelector('[name="preferred_time"]');
    if (date) {
      date.value = '';
      date.classList.remove('is-weekend-selected');
    }
    if (time) time.value = '';
    planner.removeAttribute('data-prepared-zip');
    planner._brAvailabilityVersion = (planner._brAvailabilityVersion || 0) + 1;
    planner.setAttribute('data-availability-state', 'idle');
    var availabilityMessage = planner.querySelector('[data-availability-message]');
    if (availabilityMessage) availabilityMessage.textContent = '';
  }

  function syncRequestZipFromArea(zip) {
    if (!/^\d{5}$/.test(zip)) return;
    var requestForm = document.querySelector('[data-request-form]');
    var requestZip = requestForm && requestForm.querySelector('[name="zip"]');
    if (!requestForm || !requestZip) return;
    var previousZip = normalizeZip(requestZip.value);
    requestZip.value = zip;
    requestZip.setCustomValidity('');
    populateServiceAddress(requestForm);
    if (previousZip === zip) return;
    resetRequestTiming(requestForm);
    setStatus(requestForm, '');
    var secondStep = requestForm.querySelector('[data-request-step="2"]');
    if (secondStep && !secondStep.hidden) setStep(requestForm, 1, false);
  }

  function zipIsInOneHourArea(zip) {
    var normalized = normalizeZip(zip);
    var zone = document.querySelector('[data-service-area] [data-area-zone]');
    if (!zone || !/^\d{5}$/.test(normalized)) return false;
    return (zone.getAttribute('data-zips') || '').split(',').some(function (item) {
      return normalizeZip(item) === normalized;
    });
  }

  function writeAreaResult(section, headline, detail, state, allowChange) {
    var emptyState = section && section.querySelector('[data-area-empty-state]');
    if (emptyState) emptyState.hidden = true;
    scopedNodes(section, '[data-area-result]').forEach(function (result) {
      result.hidden = false;
      result.classList.remove('is-match', 'is-review', 'is-error');
      if (state) result.classList.add(state);
      var copy = result.querySelector('[data-area-result-copy]');
      if (copy) {
        copy.textContent = '';
        var strong = document.createElement('strong');
        strong.textContent = headline;
        copy.appendChild(strong);
        if (detail) {
          var small = document.createElement('span');
          small.textContent = detail;
          copy.appendChild(small);
        }
      }
      var change = result.querySelector('[data-area-change-zip]');
      if (change) change.hidden = !allowChange;
    });
  }

  function hideAreaZipMarker(section) {
    // ZIP coverage is a service classification, not a precise map coordinate.
    // Also hide markers if an archived section is previewed in the editor.
    var marker = section && section.querySelector('[data-area-zip-marker]');
    if (marker) marker.setAttribute('hidden', '');
  }

  function checkAreaZip(form, suppliedZip) {
    if (!form) return false;
    var input = form.querySelector('[name="area_zip"]');
    var section = form.closest('[data-service-area]');
    var zip = normalizeZip(suppliedZip || (input && input.value));
    var shouldPublishResult = form.getAttribute('data-last-analytics-zip') !== zip;
    if (input) input.value = zip;
    if (!section) return false;
    if (!/^\d{5}$/.test(zip)) {
      clearAreaMatch(section);
      writeAreaResult(section, uiMessage(section, 'invalid-zip', 'Enter a valid five-digit ZIP code.'), uiMessage(section, 'invalid-zip-detail', 'Check the five digits and try again.'), 'is-error', false);
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      return false;
    }
    if (input) input.removeAttribute('aria-invalid');
    form.setAttribute('data-last-analytics-zip', zip);
    var matched = null;
    scopedNodes(section || document, '[data-area-zone]').some(function (zone) {
      var zips = (zone.getAttribute('data-zips') || '').split(',').map(function (item) { return normalizeZip(item); });
      if (zips.indexOf(zip) === -1) return false;
      matched = zone;
      return true;
    });
    syncRequestZipFromArea(zip);
    if (!matched) {
      writeAreaResult(
        section,
        fillMessage(uiMessage(section, 'review-heading', 'ZIP __ZIP__ needs a route review.'), { ZIP: zip }),
        uiMessage(section, 'review-detail', 'Submit the request with a future time preference and we will confirm whether the route is practical.'),
        'is-review',
        true
      );
      hideAreaZipMarker(section);
      var reviewExperience = section.querySelector('[data-area-experience]');
      if (reviewExperience) reviewExperience.classList.add('has-zip-result');
      if (section._brSetAreaResting) section._brSetAreaResting('0'); else setAreaZone(section, '0', false);
      setAreaControlsLocked(section, true);
      var reviewRequestZone = document.querySelector('[data-request-zone]');
      if (reviewRequestZone) {
        reviewRequestZone.textContent = fillMessage(uiMessage(section, 'review-summary', '__ZIP__ · Outside the one-hour area · availability review required'), { ZIP: zip });
        reviewRequestZone.setAttribute('data-zone-zip', zip);
        reviewRequestZone.setAttribute('data-zone-status', 'outside');
        reviewRequestZone.hidden = false;
      }
      var reviewRequestLink = section.querySelector('[data-area-request-link]');
      if (reviewRequestLink) {
        reviewRequestLink.textContent = fillMessage(uiMessage(section, 'start-request-for', 'Start a request for __ZIP__ →'), { ZIP: zip });
        reviewRequestLink.hidden = false;
      }
      if (shouldPublishResult) {
        publishAnalyticsEvent('service_area_checked', {
          route_status: 'review_required',
          service_band: 'outside_regular_route'
        });
      }
      return true;
    }
    if (matched) {
      var zoneIndex = matched.getAttribute('data-zone-index') || '1';
      var zoneTime = matched.getAttribute('data-zone-time') || '';
      var zoneTitle = matched.getAttribute('data-zone-title') || 'Service area';
      var headline = fillMessage(uiMessage(section, 'matched-heading', 'ZIP __ZIP__ is in the __TITLE__.'), { ZIP: zip, TITLE: zoneTitle });
      var detail = fillMessage(uiMessage(section, 'arrival-detail', 'Typical arrival is __TIME__, subject to availability.'), { TIME: zoneTime.toLowerCase() });
      writeAreaResult(section, headline, detail, 'is-match', true);
      hideAreaZipMarker(section);
      var experience = section.querySelector('[data-area-experience]');
      if (experience) experience.classList.add('has-zip-result');
      if (section._brSetAreaResting) section._brSetAreaResting(zoneIndex); else setAreaZone(section, zoneIndex, true);
      setAreaControlsLocked(section, true);
      var requestZone = document.querySelector('[data-request-zone]');
      if (requestZone) {
        requestZone.textContent = fillMessage(uiMessage(section, 'request-summary', '__ZIP__ · __TITLE__ · __TIME__'), { ZIP: zip, TITLE: zoneTitle, TIME: zoneTime });
        requestZone.setAttribute('data-zone-zip', zip);
        requestZone.setAttribute('data-zone-status', 'inside');
        requestZone.hidden = false;
      }
      var requestLink = section.querySelector('[data-area-request-link]');
      if (requestLink) {
        requestLink.textContent = fillMessage(uiMessage(section, 'start-request-for', 'Start a request for __ZIP__ →'), { ZIP: zip });
        requestLink.hidden = false;
      }
      if (shouldPublishResult) {
        publishAnalyticsEvent('service_area_checked', {
          route_status: 'matched',
          service_band: 'one_hour_area'
        });
      }
      if (window.innerWidth <= 580 && !suppliedZip) {
        var mobileResult = section.querySelector('.br-area-result--mobile');
        if (mobileResult) mobileResult.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      }
    }
    return true;
  }

  function setStep(form, number, focusFirst) {
    var steps = scopedNodes(form, '[data-request-step]');
    steps.forEach(function (step) { step.hidden = step.getAttribute('data-request-step') !== String(number); });
    form.setAttribute('data-current-step', String(number));
    var panel = form.closest('.br-request-panel');
    if (panel) panel.classList.toggle('is-step-two', Number(number) === 2);
    var section = form.closest('[data-request-section]') || document;
    scopedNodes(section, '[data-progress-step]').forEach(function (item) {
      var active = item.getAttribute('data-progress-step') === String(number);
      item.classList.toggle('is-active', active);
      item.classList.toggle('is-complete', Number(item.getAttribute('data-progress-step')) < number);
      if (active) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
    });
    if (!focusFirst || !steps[number - 1]) return;
    var legend = steps[number - 1].querySelector('legend');
    if (legend) {
      legend.setAttribute('tabindex', '-1');
      legend.focus({ preventScroll: true });
    }
    form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function validateFields(container) {
    var fields = scopedNodes(container, 'input, select, textarea');
    for (var i = 0; i < fields.length; i += 1) {
      if (!fields[i].checkValidity()) {
        fields[i].reportValidity();
        fields[i].focus();
        return false;
      }
    }
    return true;
  }

  function validateRequestZip(form) {
    var zipField = form && form.querySelector('[name="zip"]');
    if (!zipField) return true;
    var zip = normalizeZip(zipField.value);
    zipField.value = zip;
    var valid = /^\d{5}$/.test(zip);
    zipField.setCustomValidity(valid ? '' : uiMessage(form, 'invalid-zip', 'Enter a valid five-digit ZIP code.'));
    if (!valid) {
      zipField.reportValidity();
      zipField.focus();
    }
    return valid;
  }

  function advanceRequestForm(form) {
    var firstStep = form && form.querySelector('[data-request-step="1"]');
    if (!form || !validateRequestZip(form) || !validateFields(firstStep)) return false;
    var areaSection = document.querySelector('[data-service-area]');
    var areaChecker = areaSection && areaSection.querySelector('[data-area-checker]');
    if (areaChecker && !checkAreaZip(areaChecker, formValue(form, 'zip'))) return false;
    prepareArrivalPlanner(form);
    if (form.getAttribute('data-analytics-request-started') !== 'true') {
      publishAnalyticsEvent('request_started', {
        lead_type: 'consumer_request',
        problem_category: formValue(form, 'device_type') || 'other',
        service_area_status: formValue(form, 'service_area_status') || 'not_checked'
      });
      form.setAttribute('data-analytics-request-started', 'true');
    }
    setStep(form, 2, true);
    return true;
  }

  function chicagoClock(planner) {
    var zone = planner.getAttribute('data-time-zone') || 'America/Chicago';
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    });
    var parts = {};
    formatter.formatToParts(new Date()).forEach(function (part) {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
    });
    return parts;
  }

  function isoDateOffset(parts, days) {
    var date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days));
    var month = String(date.getUTCMonth() + 1).padStart(2, '0');
    var day = String(date.getUTCDate()).padStart(2, '0');
    return date.getUTCFullYear() + '-' + month + '-' + day;
  }

  function formattedHourRange(startHour) {
    var locale = document.documentElement.lang || 'en-US';
    var english = /^en(?:-|$)/i.test(locale);
    var formatter = new Intl.DateTimeFormat(locale, {
      timeZone: 'UTC', hour: 'numeric', minute: '2-digit', hour12: english
    });
    var start = formatter.format(new Date(Date.UTC(2024, 0, 1, startHour, 0)));
    var end = formatter.format(new Date(Date.UTC(2024, 0, 1, startHour + 1, 0)));
    return start + '–' + end;
  }

  function availabilityEndpoint(form) {
    var requestEndpoint = form && form.getAttribute('data-workbench-endpoint') || '';
    return requestEndpoint.replace(/\/requests\/?(?:\?.*)?$/, '/availability');
  }

  function formatFutureDate(iso) {
    var pieces = String(iso || '').split('-').map(Number);
    if (pieces.length !== 3 || pieces.some(function (part) { return !Number.isFinite(part); })) return iso;
    return new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
      timeZone: 'UTC', weekday: 'long', month: 'short', day: 'numeric'
    }).format(new Date(Date.UTC(pieces[0], pieces[1] - 1, pieces[2])));
  }

  function futureDateIsWeekend(iso) {
    var pieces = String(iso || '').split('-').map(Number);
    if (pieces.length !== 3) return false;
    var weekday = new Date(Date.UTC(pieces[0], pieces[1] - 1, pieces[2])).getUTCDay();
    return weekday === 0 || weekday === 6;
  }

  // Operational feedback stays local to the request component; merchant copy
  // remains in Liquid/settings. Optional data-message-* attributes override it.
  var requestFeedback = {
    en: {
      'availability-failed': 'Available times could not be loaded. Please retry.',
      'availability-retry': 'Retry',
      'availability-wait': 'Please wait for available times to load.',
      'slot-conflict': 'That time is no longer available. Please choose another time.',
      'verification-failed': 'Verification did not complete. Please try again.',
      'rate-limited': 'Please wait __SECONDS__ seconds before trying again.',
      'submission-uncertain': 'We could not confirm receipt. Please contact us before sending again.',
      'review-fields': 'Please check the required fields before sending.'
    },
    ja: {
      'availability-failed': '空き日程を取得できませんでした。もう一度お試しください。',
      'availability-retry': 'もう一度確認する',
      'availability-wait': '空き日程の確認が終わるまでお待ちください。',
      'slot-conflict': 'その時間帯は選べなくなりました。別の時間帯をお選びください。',
      'verification-failed': '認証を完了できませんでした。もう一度お試しください。',
      'rate-limited': '__SECONDS__秒後にもう一度お試しください。',
      'submission-uncertain': '送信結果を確認できませんでした。再送信の前にお問い合わせください。',
      'review-fields': '必須項目を確認してから送信してください。'
    },
    zh: {
      'availability-failed': '暂时无法查询可选时段，请重试。',
      'availability-retry': '重试',
      'availability-wait': '正在查询可选时段，请稍候。',
      'slot-conflict': '这个时段已无法选择，请换一个时段。',
      'verification-failed': '验证未完成，请重试。',
      'rate-limited': '请等待 __SECONDS__ 秒后再试。',
      'submission-uncertain': '暂时无法确认提交结果。请先联系我们，避免重复提交。',
      'review-fields': '请检查必填信息后再提交。'
    }
  };
  function requestMessage(form, key) {
    var language = (root.lang || 'en').split('-')[0];
    return uiMessage(form, key, (requestFeedback[language] || requestFeedback.en)[key] || requestFeedback.en[key]);
  }
  var availabilityRequests = Object.create(null);
  function fetchAvailability(endpoint, force) {
    var current = availabilityRequests[endpoint];
    if (current && current.pending) return current.pending;
    if (!force && current && current.data && Date.now() - current.receivedAt < 30000) return Promise.resolve(current.data);
    var entry = { data: null, receivedAt: 0, pending: null };
    availabilityRequests[endpoint] = entry;
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
    entry.pending = fetch(endpoint + '?days=8', {
      method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store', signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('availability');
      return response.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.days)) throw new Error('availability');
      entry.data = data;
      entry.receivedAt = Date.now();
      return data;
    }).finally(function () { window.clearTimeout(timeout); entry.pending = null; });
    return entry.pending;
  }

  function renderFutureTimes(planner) {
    var date = planner.querySelector('[name="preferred_date"]');
    var select = planner.querySelector('[name="preferred_time"]');
    if (!date || !select) return;
    var selected = select.value;
    var placeholder = select.options[0] ? select.options[0].textContent : 'Choose a time';
    select.textContent = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    var availability = planner._brAvailability || { days: [] };
    var day = availability.days.filter(function (item) { return item.date === date.value; })[0];
    (day && day.slots || []).forEach(function (slot) {
      var hour = Number(String(slot).slice(0, 2));
      if (!Number.isFinite(hour)) return;
      var option = document.createElement('option');
      option.value = slot;
      option.textContent = formattedHourRange(hour);
      select.appendChild(option);
    });
    if (selected && Array.prototype.some.call(select.options, function (option) { return option.value === selected; })) select.value = selected;
  }

  function renderFutureDates(planner, availability) {
    var select = planner.querySelector('[name="preferred_date"]');
    if (!select) return;
    var today = isoDateOffset(chicagoClock(planner), 0);
    var selected = select.value;
    var placeholder = uiMessage(planner.closest('[data-request-form]'), 'date-placeholder', 'Choose a date');
    select.textContent = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    (availability.days || []).filter(function (day) { return day && day.date > today && Array.isArray(day.slots) && day.slots.length; }).slice(0, 7).forEach(function (day) {
      var option = document.createElement('option');
      option.value = day.date;
      option.textContent = formatFutureDate(day.date);
      if (futureDateIsWeekend(day.date)) option.classList.add('br-weekend-option');
      select.appendChild(option);
    });
    if (selected && Array.prototype.some.call(select.options, function (option) { return option.value === selected; })) select.value = selected;
    select.classList.toggle('is-weekend-selected', futureDateIsWeekend(select.value));
    planner._brAvailability = availability;
    renderFutureTimes(planner);
  }

  function loadFutureAvailability(planner, force) {
    var form = planner.closest('[data-request-form]');
    var endpoint = availabilityEndpoint(form);
    var message = planner.querySelector('[data-availability-message]');
    var retry = planner.querySelector('[data-availability-retry]');
    var version = (planner._brAvailabilityVersion || 0) + 1;
    planner._brAvailabilityVersion = version;
    planner.setAttribute('data-availability-state', 'loading');
    if (retry) { retry.hidden = true; retry.textContent = requestMessage(form, 'availability-retry'); }
    setFutureFieldState(planner);
    if (message) message.textContent = uiMessage(form, 'availability-loading', 'Checking available dates…');
    var request = endpoint && typeof window.fetch === 'function'
      ? fetchAvailability(endpoint, force === true) : Promise.reject(new Error('availability'));
    return request
      .then(function (data) {
        if (version !== planner._brAvailabilityVersion) return;
        renderFutureDates(planner, data);
        planner.setAttribute('data-availability-state', 'ready');
        setFutureFieldState(planner);
        if (message) message.textContent = data.days.some(function (day) { return day.slots && day.slots.length; }) ? '' : uiMessage(form, 'no-dates', 'No dates are currently available in the next seven days.');
      })
      .catch(function () {
        if (version !== planner._brAvailabilityVersion) return;
        renderFutureDates(planner, { days: [] });
        planner.setAttribute('data-availability-state', 'failed');
        setFutureFieldState(planner);
        if (message) message.textContent = requestMessage(form, 'availability-failed');
        if (retry) retry.hidden = false;
      });
  }

  function setFutureFieldState(planner) {
    var outside = planner.getAttribute('data-area-status') === 'outside';
    var futureRadio = planner.querySelector('[data-future-radio]');
    var fields = planner.querySelector('[data-future-fields]');
    var date = planner.querySelector('[name="preferred_date"]');
    var time = planner.querySelector('[name="preferred_time"]');
    var show = outside || Boolean(futureRadio && futureRadio.checked);
    var ready = planner.getAttribute('data-availability-state') === 'ready';
    if (fields) { fields.hidden = !show; fields.setAttribute('aria-busy', String(planner.getAttribute('data-availability-state') === 'loading')); }
    [date, time].forEach(function (field) {
      if (!field) return;
      field.disabled = !show || !ready || (field === time && !date.value);
      field.required = show && !outside;
      field.setCustomValidity('');
    });
  }

  function prepareArrivalPlanner(form) {
    var planner = form && form.querySelector('[data-arrival-planner]');
    if (!planner) return;
    populateServiceAddress(form);
    var zip = normalizeZip(formValue(form, 'zip'));
    var inside = zipIsInOneHourArea(zip);
    var changedZip = planner.getAttribute('data-prepared-zip') !== zip;
    var date = planner.querySelector('[name="preferred_date"]');
    var futureRadio = planner.querySelector('[data-future-radio]');
    var areaStatus = planner.querySelector('[name="service_area_status"]');
    var insideStatus = planner.querySelector('[data-arrival-inside-status]');
    var outsideStatus = planner.querySelector('[data-arrival-outside-status]');
    var immediate = planner.querySelector('[data-immediate-timing]');
    var insideHelp = planner.querySelector('[data-future-inside-help]');
    var outsideHelp = planner.querySelector('[data-future-outside-help]');

    if (changedZip) {
      scopedNodes(planner, '[name="urgency"]').forEach(function (field) { field.checked = false; });
      if (date) date.value = '';
      var oldTime = planner.querySelector('[name="preferred_time"]');
      if (oldTime) oldTime.value = '';
    }
    planner.setAttribute('data-prepared-zip', zip);
    planner.setAttribute('data-area-status', inside ? 'inside' : 'outside');
    if (areaStatus) areaStatus.value = inside ? 'Inside typical one-hour area' : 'Outside one-hour area — route review';
    if (insideStatus) insideStatus.hidden = !inside;
    if (outsideStatus) outsideStatus.hidden = inside;
    if (immediate) immediate.hidden = !inside;
    if (insideHelp) insideHelp.hidden = !inside;
    if (outsideHelp) outsideHelp.hidden = inside;

    if (futureRadio) {
      futureRadio.value = inside
        ? (planner.getAttribute('data-future-value') || 'Tomorrow or later')
        : (planner.getAttribute('data-outside-value') || 'Outside one-hour area — route review');
      if (!inside) futureRadio.checked = true;
    }
    setFutureFieldState(planner);
    loadFutureAvailability(planner, false);
  }

  function validateArrivalPlanner(form) {
    var planner = form && form.querySelector('[data-arrival-planner]');
    if (!planner) return true;
    var outside = planner.getAttribute('data-area-status') === 'outside';
    var selected = planner.querySelector('[name="urgency"]:checked');
    var futureRadio = planner.querySelector('[data-future-radio]');
    var date = planner.querySelector('[name="preferred_date"]');
    var time = planner.querySelector('[name="preferred_time"]');
    if (!selected) {
      setStatus(form, uiMessage(form, 'select-timing', 'Choose an arrival preference before submitting.'), true);
      var firstTiming = planner.querySelector('[name="urgency"]:not([hidden])');
      if (firstTiming) firstTiming.focus();
      return false;
    }
    if (futureRadio && futureRadio.checked && !outside && planner.getAttribute('data-availability-state') !== 'ready') {
      setStatus(form, requestMessage(form, planner.getAttribute('data-availability-state') === 'failed' ? 'availability-failed' : 'availability-wait'), true);
      var retry = planner.querySelector('[data-availability-retry]');
      if (retry && !retry.hidden) retry.focus();
      return false;
    }
    if (outside && Boolean(date && date.value) !== Boolean(time && time.value)) {
      var incomplete = date && !date.value ? date : time;
      if (incomplete) {
        incomplete.setCustomValidity(uiMessage(form, 'future-pair', 'Choose both a future date and time, or leave both blank.'));
        incomplete.reportValidity();
        incomplete.focus();
      }
      return false;
    }
    if (futureRadio && futureRadio.checked && !outside && (!date.value || !time.value)) {
      var requiredField = !date.value ? date : time;
      requiredField.reportValidity();
      requiredField.focus();
      return false;
    }
    return true;
  }

  function setStatus(form, message, isError, isSuccess) {
    var status = form.querySelector('[data-request-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
    status.classList.toggle('is-success', Boolean(isSuccess));
  }

  function submitRequest(form) {
    if (form.getAttribute('data-submitting') === 'true') return;
    if (form._brRetryAt && Date.now() < form._brRetryAt) return;
    // Enter in step one must behave exactly like Continue, never Send.
    if (form.getAttribute('data-current-step') !== '2') {
      advanceRequestForm(form);
      return;
    }
    var firstStep = form.querySelector('[data-request-step="1"]');
    if (!validateRequestZip(form) || !validateFields(firstStep)) {
      setStep(form, 1, true);
      return;
    }
    var preparedPlanner = form.querySelector('[data-arrival-planner]');
    if (preparedPlanner && preparedPlanner.getAttribute('data-prepared-zip') !== normalizeZip(formValue(form, 'zip'))) {
      advanceRequestForm(form);
      return;
    }
    var endpoint = form.getAttribute('data-workbench-endpoint');
    var secondStep = form.querySelector('[data-request-step="2"]');
    if (!endpoint) {
      setStatus(form, uiMessage(form, 'intake-unavailable', 'Online request intake is unavailable. Please use the contact details below.'), true);
      return;
    }
    if (!validateArrivalPlanner(form) || !validateFields(secondStep)) return;
    var planner = form.querySelector('[data-arrival-planner]');
    var future = planner && planner.querySelector('[data-future-radio]');
    var timingMode = planner && planner.getAttribute('data-area-status') === 'outside' ? 'review' : (future && future.checked ? 'future' : 'asap');
    var payload = {
      zip: formValue(form, 'zip'), urgency: formValue(form, 'urgency'), timingMode: timingMode,
      preferredDate: timingMode === 'asap' ? '' : formValue(form, 'preferred_date'), preferredTime: timingMode === 'asap' ? '' : formValue(form, 'preferred_time'), serviceAreaStatus: formValue(form, 'service_area_status'), deviceType: formValue(form, 'device_type'),
      deviceModel: formValue(form, 'device_model'), serialNumber: formValue(form, 'serial_number'), fault: formValue(form, 'fault'),
      addressLine1: formValue(form, 'address_line_1'), addressLine2: formValue(form, 'address_line_2'), addressCity: formValue(form, 'address_city'), addressState: formValue(form, 'address_state'),
      name: formValue(form, 'customer_name'), phone: formValue(form, 'phone'), email: formValue(form, 'email'),
      companyWebsite: formValue(form, 'company_website'),
      formStartedAt: Number(form.getAttribute('data-form-started-at') || Date.now()),
      source: 'ByteRescue Version B homepage request',
      locale: document.documentElement.lang || 'en'
    };
    var fingerprint = JSON.stringify(payload);
    if (!form._brSubmission || form._brSubmission.fingerprint !== fingerprint) {
      form._brSubmission = { fingerprint: fingerprint, id: window.crypto.randomUUID() };
    }
    payload.submissionId = form._brSubmission.id;
    var submitButton = form.querySelector('[type="submit"]');
    var sentToEndpoint = false;
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 20000) : null;
    if (submitButton) submitButton.disabled = true;
    form.setAttribute('data-submitting', 'true');
    setStatus(form, uiMessage(form, 'sending', 'Verifying and sending your request…'));

    requestRecaptchaToken(form).then(function (token) {
      payload.recaptchaToken = token;
      sentToEndpoint = true;
      return fetch(endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload), signal: controller ? controller.signal : undefined
      });
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = {};
        try { data = text ? JSON.parse(text) : {}; } catch (error) { data = {}; }
        if (!response.ok) {
          var failure = new Error('request-failed');
          failure.status = response.status;
          failure.code = data.code;
          failure.retryAfter = Math.max(1, Math.min(3600, Number(data.retryAfter || response.headers.get('Retry-After')) || 60));
          throw failure;
        }
        return data;
      });
    }).then(function (data) {
      publishAnalyticsEvent('generate_lead', {
        lead_type: 'consumer_request',
        problem_category: payload.deviceType || 'other',
        urgency: payload.urgency || 'not_selected'
      });
      form.removeAttribute('data-analytics-request-started');
      form.reset();
      delete form._brSubmission;
      form.setAttribute('data-form-started-at', String(Date.now()));
      setStep(form, 1, false);
      var reference = data.workOrderId ? ' ' + fillMessage(uiMessage(form, 'reference', 'Reference: __ID__.'), { ID: data.workOrderId }) : '';
      setStatus(form, uiMessage(form, 'received', 'Request received. We will review the details and contact you if it fits our scope and capacity.') + reference, false, true);
    }).catch(function (error) {
      var message = requestMessage(form, 'submission-uncertain');
      if (!sentToEndpoint) message = requestMessage(form, 'verification-failed');
      if (error.code === 'SUBMISSION_CONFLICT') {
        delete form._brSubmission;
        message = requestMessage(form, 'review-fields');
      } else if (error.code === 'AREA_MISMATCH') {
        resetRequestTiming(form);
        setStep(form, 1, true);
        message = requestMessage(form, 'review-fields');
      } else if (error.status === 409) {
        message = requestMessage(form, 'slot-conflict');
        loadFutureAvailability(planner, true).then(function () {
          var date = planner.querySelector('[name="preferred_date"]');
          if (date && !date.disabled) date.focus({ preventScroll: true });
        });
      } else if (error.status === 429) {
        message = fillMessage(requestMessage(form, 'rate-limited'), { SECONDS: error.retryAfter });
        form._brRetryAt = Date.now() + error.retryAfter * 1000;
        window.setTimeout(function () { form._brRetryAt = 0; if (submitButton && form.getAttribute('data-submitting') !== 'true') submitButton.disabled = false; }, error.retryAfter * 1000);
      } else if (error.status === 403) message = requestMessage(form, 'verification-failed');
      else if (error.status === 400) message = requestMessage(form, 'review-fields');
      setStatus(form, message, true);
    }).then(function () {
      if (timeout) window.clearTimeout(timeout);
      form.removeAttribute('data-submitting');
      if (submitButton) submitButton.disabled = Boolean(form._brRetryAt && Date.now() < form._brRetryAt);
    });
  }

  document.addEventListener('click', function (event) {
    var availabilityRetry = event.target.closest('[data-availability-retry]');
    if (availabilityRetry) { loadFutureAvailability(availabilityRetry.closest('[data-arrival-planner]'), true); return; }
    var progressStep = event.target.closest('[data-progress-step]');
    if (progressStep) {
      if (progressStep.classList.contains('is-active')) return;
      var progressSection = progressStep.closest('[data-request-section]');
      var progressForm = progressSection && progressSection.querySelector('[data-request-form]');
      if (!progressForm) return;
      if (progressStep.getAttribute('data-progress-step') === '1') setStep(progressForm, 1, true);
      else advanceRequestForm(progressForm);
      return;
    }

    var changeAreaZip = event.target.closest('[data-area-change-zip]');
    if (changeAreaZip) {
      var changeSection = changeAreaZip.closest('[data-service-area]');
      var changeExperience = changeSection && changeSection.querySelector('[data-area-experience]');
      var changeInput = changeSection && changeSection.querySelector('[name="area_zip"]');
      if (changeExperience) changeExperience.classList.remove('has-zip-result');
      if (changeSection) {
        setAreaControlsLocked(changeSection, false);
        scopedNodes(changeSection, '[data-area-result]').forEach(function (result) { result.hidden = true; });
        hideAreaZipMarker(changeSection);
        if (changeSection._brSetAreaResting) changeSection._brSetAreaResting((changeExperience && changeExperience.getAttribute('data-default-zone')) || '1');
        var resetLink = changeSection.querySelector('[data-area-request-link]');
        if (resetLink) {
          resetLink.textContent = uiMessage(changeSection, 'start-request', 'Start a request →');
          resetLink.hidden = true;
        }
      }
      var resetRequestZone = document.querySelector('[data-request-zone]');
      if (resetRequestZone) {
        resetRequestZone.hidden = true;
        resetRequestZone.removeAttribute('data-zone-status');
      }
      if (changeInput) {
        changeInput.removeAttribute('aria-invalid');
        changeInput.focus();
        changeInput.select();
      }
      return;
    }

    var zipButton = event.target.closest('[data-area-zip]');
    if (zipButton) {
      var areaSection = zipButton.closest('[data-service-area]');
      var checker = areaSection && areaSection.querySelector('[data-area-checker]');
      var selectedZip = zipButton.getAttribute('data-area-zip');
      if (checker) checkAreaZip(checker, selectedZip);
      var requestZip = document.querySelector('[data-request-form] [name="zip"]');
      if (requestZip) requestZip.value = selectedZip;
      var requestSection = document.querySelector('[data-request-section]');
      if (requestSection) requestSection.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      return;
    }

    var areaRequestLink = event.target.closest('[data-area-request-link]');
    if (areaRequestLink) {
      var areaParent = areaRequestLink.closest('[data-service-area]');
      var areaForm = areaParent && areaParent.querySelector('[data-area-checker]');
      if (areaForm && !checkAreaZip(areaForm)) {
        event.preventDefault();
        return;
      }
    }

    var problem = event.target.closest('[data-problem-option]');
    if (problem) { selectProblem(problem, true); return; }
    if (event.target.closest('[data-problem-request]')) {
      copyProblemToForm(document.querySelector('[data-problem-option].is-active'));
    }

    var next = event.target.closest('[data-request-next]');
    if (next) {
      var nextForm = next.closest('[data-request-form]');
      if (nextForm) advanceRequestForm(nextForm);
      return;
    }
    var back = event.target.closest('[data-request-back]');
    if (back) { setStep(back.closest('[data-request-form]'), 1, true); }
  });

  document.addEventListener('submit', function (event) {
    if (event.target.matches('[data-area-checker]')) {
      event.preventDefault();
      checkAreaZip(event.target);
      return;
    }
    if (event.target.matches('[data-request-form]')) {
      event.preventDefault();
      submitRequest(event.target);
      return;
    }
  });

  document.addEventListener('change', function (event) {
    var arrivalPlanner = event.target.closest('[data-arrival-planner]');
    if (arrivalPlanner && event.target.matches('[name="urgency"], [name="preferred_date"], [name="preferred_time"]')) {
      if (event.target.matches('[name="urgency"]')) setFutureFieldState(arrivalPlanner);
      if (event.target.matches('[name="preferred_date"]')) {
        event.target.classList.toggle('is-weekend-selected', futureDateIsWeekend(event.target.value));
        renderFutureTimes(arrivalPlanner);
        setFutureFieldState(arrivalPlanner);
      }
      event.target.setCustomValidity('');
      var arrivalForm = arrivalPlanner.closest('[data-request-form]');
      if (arrivalForm) setStatus(arrivalForm, '');
      return;
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-arrival-planner] [name="preferred_date"], [data-arrival-planner] [name="preferred_time"]')) {
      event.target.setCustomValidity('');
      return;
    }
    if (event.target.matches('[data-request-form] [name="zip"]')) {
      event.target.setCustomValidity('');
      var zoneSummary = document.querySelector('[data-request-zone]');
      if (zoneSummary && normalizeZip(event.target.value) !== zoneSummary.getAttribute('data-zone-zip')) zoneSummary.hidden = true;
      var editedForm = event.target.closest('[data-request-form]');
      resetRequestTiming(editedForm);
      return;
    }
    if (event.target.matches('[data-area-checker] [name="area_zip"]')) {
      var editedArea = event.target.closest('[data-service-area]');
      if (editedArea) clearAreaMatch(editedArea);
      return;
    }
    if (event.target.matches('[data-address-city], [data-address-state]')) {
      event.target.removeAttribute('data-br-autofilled');
      if (event.target.matches('[data-address-state]')) event.target.value = event.target.value.toUpperCase();
    }
  });

  window.addEventListener('resize', function () {
    scopedNodes(document, '[data-problem-section]').forEach(configureProblemSection);
  });
  function initializeRequestForms(scope) {
    initializeRequestSecurity(scope);
    // Validate the active step ourselves, so hidden required fields in step two
    // cannot intercept a first-step Enter before our submit handler runs.
    scopedNodes(scope, '[data-request-form]').forEach(function (form) { form.noValidate = true; });
  }
  initializeRequestForms(document);

  scopedNodes(document, '[data-problem-section]').forEach(function (section) {
    configureProblemSection(section);
  });
  scopedNodes(document, '[data-service-area]').forEach(initializeArea);

  document.addEventListener('shopify:section:load', function (event) {
    scopedNodes(event.target, '[data-problem-section]').forEach(function (section) {
      section.removeAttribute('data-problem-mode');
      configureProblemSection(section);
    });
    scopedNodes(event.target, '[data-service-area]').forEach(initializeArea);
    initializeRequestForms(event.target);
  });
})();
